import jsPDF from "jspdf";
import firebase from "../../config/firebase";
import { toast } from "react-toastify";

export const getMyRequests = (id) => async (dispatch) => {
    dispatch(fanLoader(true));
    try {
        firebase
            .firestore()
            .collection("momento_requests")
            .where("fan_id", "==", id)
            .onSnapshot((query) => {
                let myRequests = [];
                for (let doc of query.docs) {
                    if (doc.exists) {
                        myRequests.push({ id: doc.id, ...doc.data() });
                    }
                }
                dispatch({
                    type: "MY_REQUESTS",
                    payload: myRequests,
                });
            });
        dispatch(fanLoader(false));
    } catch (error) {
        dispatch(fanLoader(false));
        toast.error("error", error);
    }
};
export const getAllMomentos =
    (filters, lastDocument, onSuccess = () => {}) =>
    async (dispatch) => {
        try {
            console.log(filters);
            let quary = firebase
                .firestore()
                .collection("momentos")
                .where("private", "==", false)
                .where("isDeleted", "==", false);
            if (filters.athleteFirstName) {
                quary = quary.where(
                    "athleteName",
                    "==",
                    filters.athleteFirstName
                );
            }
            if (filters.momentoID) {
                quary = quary.where("momentoID", "==", filters.momentoID);
            }
            if (filters.athleteID) {
                quary = quary.where(
                    "athleteID",
                    "==",
                    Number(filters.athleteID)
                );
            }
            quary.orderBy("createdAt", "desc");
            if (lastDocument) {
                quary = quary.startAfter(lastDocument);
            }
            quary
                .limit(10)
                .get()
                .then((query) => {
                    let gallery = [];
                    for (let doc of query.docs) {
                        gallery.push({ id: doc.id, ...doc.data() });
                    }
                    console.log(gallery);
                    dispatch({
                        type: lastDocument ? "FAN_GALLERY_MORE" : "FAN_GALLERY",
                        payload: {
                            data: gallery,
                            lastDocument: query.docs[gallery.length - 1],
                            hasMore: gallery.length >= 10,
                        },
                    });
                    onSuccess();
                });
        } catch (error) {
            toast.error("error", error);
        }
    };

// export const fetchMoreGallery =
//     (lastItem, onError = () => {}) =>
//     async (dispatch) => {
//         firebase
//             .firestore()
//             .collection("momentos")
//             .where("private", "==", false)
//             .where("isDeleted", "==", false)
//             .orderBy("createdAt", "desc")
//             .limit(10)
//             .startAfter(lastItem.createdAt)
//             .onSnapshot((query) => {
//                 let moreGallery = [];
//                 for (let doc of query.docs) {
//                     moreGallery.push({ id: doc.id, ...doc.data() });
//                 }
//                 if (moreGallery.length === 0) {
//                     onError();
//                 }
//                 dispatch({
//                     type: "FAN_GALLERY_MORE",
//                     payload: moreGallery,
//                 });
//             });
//     };

export const getAllUsers = () => async (dispatch) => {
    dispatch(fanLoader(true));
    try {
        firebase
            .firestore()
            .collection("users")
            .where("role", "==", "athlete")
            .onSnapshot((query) => {
                let allAthletes = [];
                for (let doc of query.docs) {
                    allAthletes.push({ id: doc.id, ...doc.data() });
                }
                dispatch({
                    type: "ALL_USERS",
                    payload: allAthletes,
                });
            });
        dispatch(fanLoader(false));
    } catch (error) {
        dispatch(fanLoader(false));
        toast.error("error", error);
    }
};
export const submitMomentoRequest =
    (payload, onSuccess = () => {}) =>
    async (dispatch) => {
        dispatch(fanLoader(true));
        try {
            firebase
                .firestore()
                .collection("momento_requests")
                .add(payload)
                .then((docRef) => {
                    const docId = docRef.id;
                    onSuccess(docId);
                    dispatch(fanLoader(false));
                });
        } catch (error) {
            dispatch(fanLoader(false));
            toast.error("error", error);
        }
    };
export const buyMomento =
    (payload, onSuccess = () => {}) =>
    async (dispatch) => {
        dispatch(fanLoader(true));

        let updatedPayload = {
            ...payload,
            createdAt: firebase.firestore.Timestamp.now(),
        };
        try {
            firebase
                .firestore()
                .collection("momento_purchases")
                .add(updatedPayload)
                .then(onSuccess(), dispatch(fanLoader(false)));
        } catch (error) {
            dispatch(fanLoader(false));
            toast.error("error", error);
        }
    };
export const getAllBoughtMomentos = (uid) => async (dispatch) => {
    dispatch(fanMementoLoader(true));
    try {
        firebase
            .firestore()
            .collection("momento_purchases")
            .where("fan_id", "==", uid)
            .onSnapshot(async (query) => {
                let PurchasedMomentos = [];
                for (let doc of query.docs) {
                    if (doc.exists) {
                        const data = doc.data();
                        if (data?.type == "normal") {
                            await firebase
                                .firestore()
                                .collection("momentos")
                                .doc(data.momentoId)
                                .get()
                                .then((document) => {
                                    if (document.exists) {
                                        PurchasedMomentos.push({
                                            purchasedMomentoId: doc.id,
                                            momentoId: document.id,
                                            ...document.data(),
                                        });
                                    }
                                });
                        } else if (data?.type == "request") {
                            await firebase
                                .firestore()
                                .collection("momentos")
                                .where("requestId", "==", data?.requestId)
                                .get()
                                .then((document) => {
                                    for (let query of document.docs) {
                                        if (query.exists) {
                                            PurchasedMomentos.push({
                                                purchasedMomentoId: doc.id,
                                                momentoId: query.id,
                                                ...query.data(),
                                            });
                                        }
                                    }
                                });
                        }
                    }
                }
                dispatch({
                    type: "FAN_BOUGHT_GALLERY",
                    payload: PurchasedMomentos,
                });
            });
        dispatch(fanMementoLoader(false));
    } catch (error) {
        dispatch(fanMementoLoader(false));
        toast.error("error", error);
    }
};

export const searchAthlete =
    (type, value, onSuccess = (res) => {}) =>
    async (dispatch) => {
        try {
            await firebase
                .firestore()
                .collection("users")
                .where("role", "==", "athlete")
                .onSnapshot((query) => {
                    const foundAthletes = [];
                    if (type === "name") {
                        let Name = value.split(" ");
                        for (let doc of query.docs) {
                            let data = doc.data();
                            if (
                                data?.first_name.toLowerCase() ==
                                    Name[0]?.toLowerCase() ||
                                data?.last_name.toLowerCase() ==
                                    Name[1]?.toLowerCase()
                            ) {
                                foundAthletes.push({ id: doc.id, ...data });
                            }
                        }
                    } else if (type === "last_name") {
                        let Name = value;
                        for (let doc of query.docs) {
                            let data = doc.data();
                            if (
                                data?.last_name.toLowerCase() ==
                                Name.toLowerCase()
                            ) {
                                console.log("hitted");
                                foundAthletes.push({ id: doc.id, ...data });
                                console.log(foundAthletes);
                            } else {
                                console.log("else hitted");
                            }
                        }
                    } else {
                        for (let doc of query.docs) {
                            let data = doc.data();
                            if (data?.athleteID?.toString() === value) {
                                foundAthletes.push({ id: doc.id, ...data });
                            }
                        }
                    }
                    onSuccess(foundAthletes);
                });
        } catch (error) {
            toast.error("error", error);
        }
    };

const fetchAndEncodeImage = async (imageUrl) => {
    const corsAnywhereUrl = `https://cors-platform-2-44c3877bb9f7.herokuapp.com/${imageUrl}`;
    try {
        const response = await fetch(corsAnywhereUrl);
        if (response.ok) {
            const blob = await response.blob();
            const base64String = await blobToBase64(blob);
            return base64String;
        } else {
            throw new Error("Failed to fetch the image.");
        }
    } catch (error) {
        console.error("Error fetching and encoding image:", error);
        return null;
    }
};

// Define a function to convert a blob to base64
const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(",")[1]);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

export const downLoadMomento =
    (file, fanName, onSuccess = () => {}) =>
    async (dispatch) => {
        console.log(fanName);
        dispatch(fanLoader(true));
        try {
            const pdf = new jsPDF("l", "in", [file?.momentoSize, 8.5]);
            const topMargin = 1; // 1 inch top margin
            const leftMargin = 1; // 1 inch left margin
            const rightMargin = 1; // 1 inch right margin
            const bottomMargin = 1; // 1 inch bottom margin

            // Calculate column width
            const columnWidth =
                (file?.momentoSize - leftMargin - rightMargin) / 2;
            const qrCodeSize = 1.5;

            // QrCode First column
            const qrCodesToDisplay1st = file.qrCodes.slice(0, 2);
            for (const [index, qrCode] of qrCodesToDisplay1st.entries()) {
                const xPosition = leftMargin;
                const yPosition = topMargin + 0.75 + index * (qrCodeSize + 0.5);
                if (qrCode !== "") {
                    pdf.addImage(
                        await fetchAndEncodeImage(qrCode),
                        "JPEG",
                        xPosition,
                        yPosition,
                        qrCodeSize,
                        qrCodeSize
                    );
                }
            }
            // Images , title and subTitles
            const boxWidth = 2.5;
            const boxHeight = 4.5;
            let currentXPosition = leftMargin + qrCodeSize + 0.375;
            const boxYPosition = topMargin;

            for (let item of file.momento) {
                pdf.setFillColor(255, 255, 255);
                pdf.rect(
                    currentXPosition,
                    boxYPosition,
                    boxWidth,
                    boxHeight,
                    "F"
                ); // 'F' fills the rectangle

                pdf.setFontSize(18);
                pdf.setFont("times", "bold");

                // Assuming title, subtitle, and media are properties of the 'item' object
                pdf.text(
                    toTitleCase(item.title),
                    currentXPosition - 0.05,
                    topMargin + 0.35
                );
                pdf.setFontSize(14);
                pdf.setFont("times", "normal");
                pdf.text(
                    item.subTitle,
                    currentXPosition - 0.05,
                    topMargin + 0.85
                );

                const imgData = item.media
                    ? await fetchAndEncodeImage(item.media)
                    : null;
                if (imgData) {
                    pdf.addImage(
                        imgData,
                        "JPEG",
                        currentXPosition,
                        topMargin + 1.25,
                        boxWidth,
                        3
                    );
                }

                currentXPosition += boxWidth + 0.25; // Adjust horizontal position and spacing as needed
            }

            // QrCode last column
            const qrCodesToDisplay = file.qrCodes.slice(-2).reverse();

            for (const [index, qrCode] of qrCodesToDisplay.entries()) {
                const xPosition = file?.momentoSize - rightMargin - 1.5;
                const yPosition = topMargin + 0.75 + index * (qrCodeSize + 0.5);

                if (qrCode !== "") {
                    pdf.addImage(
                        await fetchAndEncodeImage(qrCode),
                        "JPEG",
                        xPosition,
                        yPosition,
                        qrCodeSize,
                        qrCodeSize
                    );
                }
            }
            // QrCode Bottom Row
            const additionalXspace = file.momento.length > 2 ? 0.25 : 0.375;
            const xIncrement = 1.5 + additionalXspace;

            for (let index = 2; index < file.qrCodes.length - 2; index++) {
                let qrCode = file.qrCodes[index];
                const xPosition = leftMargin + (index - 2) * xIncrement; // Adjusted index to start from 0
                const yPosition = 5.75;

                if (qrCode !== "") {
                    pdf.addImage(
                        await fetchAndEncodeImage(qrCode),
                        "JPEG",
                        xPosition,
                        yPosition,
                        qrCodeSize,
                        qrCodeSize
                    );
                } else {
                    // Add an empty space (you can customize the size/color as needed)
                    pdf.setFillColor(255, 255, 255);
                    pdf.rect(xPosition, yPosition, qrCodeSize, qrCodeSize, "F");
                }
            }

            //Websites
            pdf.setFontSize(8);
            pdf.text(
                `Test Link: https://fans-help-players-athlete.web.app/verify/momento/${file.purchasedMomentoId}`,
                0.2,
                0.2
            );
            pdf.setFontSize(12);
            pdf.text(`Purchased By: ${fanName}`, 0.5, 0.5);
            pdf.setFontSize(16);
            pdf.setFont("times", "normal");
            pdf.text("FansHelpPlayers.com", leftMargin, 7.75);
            pdf.text(
                file?.schoolName || "MementoMATIC.com",
                file?.momentoSize - rightMargin - 1.5,
                7.75
            );
            // Save the PDF
            pdf.save(`${file.momentoTitle}_${file.momentoSize}_momento`);
            // pdf.autoPrint();
            // window.open(pdf.output("bloburl"), "_blank");

            dispatch(fanLoader(false));
            dispatch(updateDownload(file.purchasedMomentoId));
            onSuccess();
        } catch (error) {
            dispatch(fanLoader(false));
            toast.error(error, "error");
        }
    };

export const updateDownload = (ID) => async (dispatch) => {
    try {
        firebase
            .firestore()
            .collection("momento_purchases")
            .doc(ID)
            .update({
                downloads: firebase.firestore.FieldValue.increment(1),
            });
    } catch (error) {
        toast.error("error", error);
    }
};

export const fanLoader = (val) => async (dispatch) => {
    dispatch({
        type: "Loading",
        payload: val,
    });
};
export const fanMementoLoader = (val) => async (dispatch) => {
    dispatch({
        type: "FAN_Loading",
        payload: val,
    });
};
